import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from "@angular/core";
import { NovaIcon } from "@rds-nova/angular-icon";
import { SlotPresentation } from "../../ron-closing-monitor.utils";

@Component({
  selector: "app-slot-pill",
  templateUrl: "./slot-pill.component.html",
  styleUrls: ["./slot-pill.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NovaIcon],
})
export class SlotPillComponent implements OnChanges {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input({ required: true }) presentation!: SlotPresentation;
  @Input() interactive = false;
  @Input() expanded = false;
  @Input() controls: string | null = null;

  @Output() activate = new EventEmitter<void>();

  overflowTitle: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["presentation"]) {
      this.overflowTitle = null;
    }
  }

  onClick(): void {
    if (this.interactive) {
      this.activate.emit();
    }
  }

  onHover(): void {
    const label = this.host.nativeElement.querySelector<HTMLElement>(
      ".rcm-pill__label"
    );
    const clipped = label !== null && label.scrollWidth > label.clientWidth;
    this.overflowTitle = clipped ? this.presentation.label : null;
  }
}
